let zipcodeUrl = 'https://cdn.shopify.com/s/files/1/0011/1729/0614/files/Zipcode_list_-_08072026_601b82c6-4f7d-4d97-8b9e-be3a7c268520.csv?v=1786121419'
const DEFAULT_LOCATION_STATE = 'ATL';
let zipcodeListCache = null;

// Fetch the CSV file from the assets folder
async function fetchZipcodeList() {
    try {
        const response = await fetch(zipcodeUrl);
        const csvText = await response.text();

        // Split the CSV text into rows
        const rows = csvText.split('\n');

        // Extract the headers (assuming the first row contains headers)
        const headers = rows[0].split(',').map(header => header.trim());

        // Parse the rest of the CSV rows into an array of objects
        const data = rows.slice(1).map(row => {
            const values = row.split(',');
            let obj = {};
            headers.forEach((header, index) => {
                obj[header] = values[index].trim();
            });
            return obj;
        });

        zipcodeListCache = data;
        return data;
    } catch (error) {
        console.error('Error fetching or processing the CSV file:', error);
        return [];
    }
}

async function getZipcodeList() {
    if (zipcodeListCache) {
        return zipcodeListCache;
    }
    return fetchZipcodeList() || [];
}

function findFirstLocationByState(zipcodeList, stateAbrev) {
    return zipcodeList.find(item => item.location_abrev === stateAbrev);
}

function updateZipcodeOutputs(zipcode) {
    if (!zipcode || zipcode === 'not found') {
        return;
    }
    document.querySelectorAll('.zipcode-output').forEach(output => {
        output.value = zipcode;
    });
}

function formatServescapePrice(amount) {
    var value = Number(amount);
    if (isNaN(value)) {
        return '$0.00';
    }

    var isNegative = value < 0;
    value = Math.abs(value);
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (isNegative ? '-' : '') + '$' + parts.join('.');
}
window.formatServescapePrice = formatServescapePrice;

function variantTracksInventory(variant) {
    return !!(variant && variant.inventory_management === 'shopify');
}
window.variantTracksInventory = variantTracksInventory;

function getServescapeVariantById(variantId) {
    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!variantJsonEl) {
        return null;
    }
    var variants = JSON.parse(variantJsonEl.textContent);
    return variants.find(function (variant) {
        return variant.id === Number(variantId);
    }) || null;
}
window.getServescapeVariantById = getServescapeVariantById;

function getServescapeVariantId(variant) {
    if (!variant) {
        return null;
    }
    var id = variant.variantId != null ? variant.variantId : variant.id;
    return id != null && !isNaN(Number(id)) ? Number(id) : null;
}

function resolveServescapeVariantPrices(variant) {
    var variantId = getServescapeVariantId(variant);
    var shopifyVariant = variantId ? getServescapeVariantById(variantId) : null;
    if (shopifyVariant) {
        return {
            price: shopifyVariant.price / 100,
            compareAtPrice: shopifyVariant.compare_at_price ? shopifyVariant.compare_at_price / 100 : 0
        };
    }

    var price = Number(variant.variantPrice != null ? variant.variantPrice : variant.price);
    var compareAtPrice = Number(
        variant.variantCompareAtPrice != null ? variant.variantCompareAtPrice : variant.compare_at_price
    );
    return {
        price: isNaN(price) ? 0 : price,
        compareAtPrice: isNaN(compareAtPrice) ? 0 : compareAtPrice
    };
}
window.resolveServescapeVariantPrices = resolveServescapeVariantPrices;

function syncServescapeVariantState(matchingVariant, productContainer) {
    if (!matchingVariant || !productContainer) {
        return;
    }

    var variantId = matchingVariant.id.toString();
    var variantSelect = productContainer.querySelector('[data-product-select]');

    if (variantSelect) {
        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    localStorage.setItem('selected_variant_id', variantId);

    if (history.replaceState) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + matchingVariant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
    }

    productContainer.dispatchEvent(new CustomEvent('variantChange', {
        detail: { variant: matchingVariant }
    }));
}
window.syncServescapeVariantState = syncServescapeVariantState;

function updateWindowInventories(productId, data) {
    if (!data || !Array.isArray(data)) {
        return;
    }
    var locationId = localStorage.getItem('current_location_id');
    if (locationId === 'not found' || locationId === null) {
        return;
    }
    window.inventories = window.inventories || {};
    window.inventories[productId] = {};
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var inv = item.inventory;
        window.inventories[productId][item.variantId] = {
            quantity: Array.isArray(inv) && inv.length > 0 && inv[0].available,
            location_id: locationId,
            price: item.variantPrice,
            compare_at_price: item.variantCompareAtPrice,
            weight: item.variantWeight,
        };
    }
}

function getSelectedVariantFromData(data, productContainer) {
    if (!data || !data.length) {
        return null;
    }

    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (variantJsonEl && productContainer) {
        var variants = JSON.parse(variantJsonEl.textContent);
        var selectedOptions = {};
        productContainer.querySelectorAll('[data-variant-input]').forEach(function (input) {
            if (input.type === 'radio' && input.checked) {
                selectedOptions[input.dataset.index] = input.value;
            } else if (input.type !== 'radio' && input.value) {
                selectedOptions[input.dataset.index] = input.value;
            }
        });

        if (Object.keys(selectedOptions).length) {
            var matchingVariant = variants.find(function (variant) {
                return Object.keys(selectedOptions).every(function (optionIndex) {
                    return variant[optionIndex] === selectedOptions[optionIndex];
                });
            });
            if (matchingVariant) {
                var fromChecked = data.find(function (item) {
                    return item.variantId === matchingVariant.id;
                });
                if (fromChecked) {
                    return fromChecked;
                }
            }
        }
    }

    var selectedVariantId = localStorage.getItem('selected_variant_id');
    if (selectedVariantId && selectedVariantId !== 'none') {
        var fromStorage = data.find(function (item) {
            return item.variantId === Number(selectedVariantId);
        });
        if (fromStorage) {
            return fromStorage;
        }
    }

    var firstAvailable = data.find(function (item) {
        return Array.isArray(item.inventory) && item.inventory.length > 0 && item.inventory[0].available > 0;
    });
    if (firstAvailable) {
        return firstAvailable;
    }

    return data[0];
}

async function productDisplayPriceHandle() {
    var productContainer = document.querySelector('.ss--product-template__container');
    var priceBlock = productContainer && productContainer.querySelector('.product-block--price');
    if (!productContainer || !priceBlock) {
        return;
    }

    var productId = productContainer.getAttribute('data-product-id');
    var locationId = localStorage.getItem('current_location_id');
    var url = 'https://ss-backend-custom-app.uc.r.appspot.com/inventory/' + productId + '/' + locationId;
    var priceApplied = false;

    try {
        var response = await fetch(url);
        if (response.ok) {
            var contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                var data = await response.json();
                if (Array.isArray(data) && data.length) {
                    updateWindowInventories(productId, data);

                    if (document.querySelector('.ss--variant-wrapper') && typeof variantButtonsHandler === 'function') {
                        variantButtonsHandler();
                    }

                    var selectedVariant = getSelectedVariantFromData(data, productContainer);
                    if (selectedVariant) {
                        ssProductPriceHandle(selectedVariant);
                        priceApplied = true;
                    }
                }
            }
        }
    } catch (error) {
        console.error('Error fetching product price:', error);
    }

    // Gift cards / non-inventory products: fall back to Shopify variant JSON.
    if (!priceApplied) {
        applyProductPriceFromShopifyVariants(productContainer);
    }
}

function applyProductPriceFromShopifyVariants(productContainer) {
    productContainer = productContainer || document.querySelector('.ss--product-template__container');
    if (!productContainer) {
        return;
    }

    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!variantJsonEl) {
        return;
    }

    var variants;
    try {
        variants = JSON.parse(variantJsonEl.textContent);
    } catch (e) {
        return;
    }
    if (!Array.isArray(variants) || !variants.length) {
        return;
    }

    var selectedOptions = {};
    productContainer.querySelectorAll('[data-variant-input]').forEach(function (input) {
        if (input.type === 'radio' && input.checked) {
            selectedOptions[input.dataset.index] = input.value;
        } else if (input.type !== 'radio' && input.value) {
            selectedOptions[input.dataset.index] = input.value;
        }
    });

    var matchingVariant = null;
    if (Object.keys(selectedOptions).length) {
        matchingVariant = variants.find(function (variant) {
            return Object.keys(selectedOptions).every(function (optionIndex) {
                return variant[optionIndex] === selectedOptions[optionIndex];
            });
        });
    }

    if (!matchingVariant) {
        var selectedVariantId = localStorage.getItem('selected_variant_id');
        if (selectedVariantId && selectedVariantId !== 'none') {
            matchingVariant = variants.find(function (variant) {
                return variant.id === Number(selectedVariantId);
            });
        }
    }

    if (!matchingVariant) {
        matchingVariant = variants.find(function (variant) {
            return variant.available !== false;
        }) || variants[0];
    }

    if (matchingVariant) {
        ssProductPriceHandle(matchingVariant);
    }
}

function ssProductPriceHandle(variant) {
    if (!variant) {
        return;
    }
    var productContainer = document.querySelector('.ss--product-template__container');
    if (!productContainer) {
        return;
    }
    var priceBlocks = productContainer.querySelectorAll('.product-block--price');
    if (!priceBlocks.length) {
        return;
    }

    var productType = priceBlocks[0].getAttribute('data-product-type');
    var servescape_pro = window.localStorage.getItem('servescape_pro') === 'true';
    var displayDiscountPercent = typeof window.getServescapeProductDisplayDiscountPercent === 'function'
        ? window.getServescapeProductDisplayDiscountPercent(productType)
        : 0;
    var resolvedPrices = resolveServescapeVariantPrices(variant);
    var price = resolvedPrices.price;
    var compareAtPrice = resolvedPrices.compareAtPrice;
    var showSale = compareAtPrice > 0 && price < compareAtPrice;
    var finalPriceText = formatServescapePrice(price);
    var originalPriceText = formatServescapePrice(price);
    var showDiscountedOriginal = false;

    var showProLabel = servescape_pro
        && typeof window.isServescapeDiscountExcluded === 'function'
        && !window.isServescapeDiscountExcluded(productType);

    if (displayDiscountPercent > 0 && !servescape_pro) {
        finalPriceText = formatServescapePrice(price * (1 - displayDiscountPercent / 100));
        showDiscountedOriginal = true;
    } else if (showProLabel) {
        var plantsDiscount = 0.30;
        finalPriceText = formatServescapePrice(price - (price * plantsDiscount));
        showDiscountedOriginal = true;
    }

    priceBlocks.forEach(function (priceBlock) {
        var spanFinalPrice = priceBlock.querySelector('.ss--product__final-price');
        var spanOriginalPrice = priceBlock.querySelector('.ss--product__orginal-price');
        var spanCompareAtPrice = priceBlock.querySelector('.ss--product__compare-at-price');
        var spanSaleLabel = priceBlock.querySelector('.ss--product__sale-label');
        var spanProLabel = priceBlock.querySelector('.ss--product__pro-label');

        if (!spanFinalPrice) {
            return;
        }

        if (spanCompareAtPrice) {
            spanCompareAtPrice.innerText = compareAtPrice > 0 ? formatServescapePrice(compareAtPrice) : '';
        }
        if (spanSaleLabel) {
            spanSaleLabel.classList.toggle('hide', !showSale);
        }
        if (spanProLabel) {
            spanProLabel.classList.toggle('hide', !showProLabel);
        }
        if (spanOriginalPrice) {
            spanOriginalPrice.classList.toggle('hide', !showDiscountedOriginal);
            spanOriginalPrice.innerText = originalPriceText;
        }
        spanFinalPrice.innerText = finalPriceText;
    });
}


function ssVariantClickHandle(variantButton) {
    const productContainer = document.querySelector('.ss--product-template__container')
    if (!productContainer) return

    const productId = productContainer.getAttribute('data-product-id')
    const variantJsonEl = document.querySelector('[data-variant-json]')
    const inventoryText = document.querySelector('.ss--inventory-amount')
    const inventoryIcon = document.querySelector('.ss--inventory-icon-text .icon');
    const ctaButton = document.querySelector('.ss--cta-button.add-to-cart');
    const inputQuantity = document.querySelector('.product__quantity .ss--quantity-input__wrapper input')

    const clickedInput = variantButton.querySelector('input[type="radio"]')
    if (clickedInput) {
        var wasChecked = clickedInput.checked
        clickedInput.checked = true
        if (!wasChecked) {
            clickedInput.dispatchEvent(new Event('change', { bubbles: true }))
        }
    }

    if (!variantJsonEl) {
        return
    }

    // Get all variants from JSON
    const variants = JSON.parse(variantJsonEl.textContent)

    // Collect all currently selected option values
    const selectedOptions = {}
    const allOptionInputs = productContainer.querySelectorAll('[data-variant-input]')

    allOptionInputs.forEach(input => {
        if (input.type === 'radio' && input.checked) {
            const optionIndex = input.dataset.index // e.g., "option1", "option2", "option3"
            selectedOptions[optionIndex] = input.value
        } else if (input.type !== 'radio' && input.value) {
            const optionIndex = input.dataset.index
            selectedOptions[optionIndex] = input.value
        }
    })

    // Find the variant that matches all selected options
    const matchingVariant = variants.find(variant => {
        return Object.keys(selectedOptions).every(optionIndex => {
            return variant[optionIndex] === selectedOptions[optionIndex]
        })
    })

    if (!matchingVariant) {
        // No matching variant found, might be an invalid combination
        return
    }

    syncServescapeVariantState(matchingVariant, productContainer)

    const variantId = matchingVariant.id.toString()
    const tracksInventory = variantTracksInventory(matchingVariant)
    const inventoryRecord = window.inventories && window.inventories[productId]
        ? window.inventories[productId][variantId]
        : null

    if (tracksInventory && !inventoryRecord) {
        return
    }

    // Update price from Shopify catalog; inventory API is used for stock only.
    ssProductPriceHandle(matchingVariant)

    // Untracked inventory is always purchasable; tracked inventory uses location stock.
    const variantQuantity = inventoryRecord ? (inventoryRecord.quantity || 0) : 0
    const isAvailable = tracksInventory ? Number(variantQuantity) > 0 : matchingVariant.available !== false

    if (isAvailable) {
        if (tracksInventory) {
            inputQuantity && inputQuantity.setAttribute('max', variantQuantity)
            if (inventoryText) {
                inventoryText.innerText = `${variantQuantity} available`;
                inventoryText.style = "color: #2E5035;"
            }
            if (inventoryIcon) {
                inventoryIcon.style = "visibility: visible";
            }
        }
        if (ctaButton) {
            ctaButton.style.display = 'inline-block'
            ctaButton.disabled = false
        }
    } else {
        inputQuantity && inputQuantity.setAttribute('max', 0)
        if (inventoryText) {
            inventoryText.innerText = 'Out of stock';
            inventoryText.style = "color: red"
        }
        if (inventoryIcon) {
            inventoryIcon.style = "visibility: hidden; width: 0px; margin: 0";
        }
        if (ctaButton) {
            ctaButton.style.display = 'none'
        }
    }
}

function zipModalPopupHandler() {
    const zipModal = document.querySelector(' .ss--zipcode-modal-popup');
    zipModal.classList.add('showup');
}

function zipModalCloseHandler() {
    const zipModal = document.querySelector('.ss--zipcode-modal-popup');
    zipModal.classList.remove('showup')
}


function getZipPopupElements() {
    const modal = document.querySelector('.ss--zipcode-modal-popup');
    if (!modal) {
        return null;
    }
    return {
        input: modal.querySelector('input#zip'),
        zipMessage: modal.querySelector('.zip-message'),
        spinner: modal.querySelector('.spinner-save-zip'),
        textBtn: modal.querySelector('.save-zip-text'),
        saveBtn: modal.querySelector('.save-zip-btn'),
    };
}

function resetSaveZipButton(elements) {
    if (!elements) {
        return;
    }
    if (elements.spinner) {
        elements.spinner.style.visibility = 'hidden';
    }
    if (elements.textBtn) {
        elements.textBtn.style.visibility = 'visible';
    }
    if (elements.saveBtn) {
        elements.saveBtn.disabled = false;
    }
}

function validateInput() {
    const elements = getZipPopupElements();
    const input = elements && elements.input ? elements.input : document.querySelector('input#zip');
    if (!input) {
        return;
    }

    input.value = input.value.replace(/\D/g, '').slice(0, 5);

    if (elements && elements.zipMessage) {
        elements.zipMessage.textContent = '';
    }
}

function googleCurrentLocationHandle() {
    let latitude;
    let longitude;
    let storageZipcode
    const buttonText = document.querySelector('.button-text')
    const spinner = document.querySelector('.spinner')
    const currentButton = document.querySelector('.current-zip-btn')

    spinner.style.visibility = 'visible'; // Show spinner
    buttonText.style.visibility = 'hidden'; // Hide text
    currentButton.disabled = true; // Disable button to prevent multiple clicks

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                latitude = position.coords.latitude;
                longitude = position.coords.longitude;
                if (latitude && longitude) {
                    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBtmiQczD6oNCBS-VmAPZbBW1G0EuZsrJk`)
                        .then(response => response.json())
                        .then(data => {
                            if (data.status === 'OK') {
                                storageZipcode = data.results[0].address_components[6].long_name
                                findZipcodeAndUpdateLocalStorage(storageZipcode).then(function (result) {
                                    if (!result.found) {
                                        const popup = getZipPopupElements();
                                        if (popup && popup.zipMessage) {
                                            popup.zipMessage.textContent = 'Sorry, this zip code is not served in our delivery area.';
                                            popup.zipMessage.style.color = 'red';
                                        }
                                        spinner.style.visibility = 'hidden';
                                        buttonText.style.visibility = 'visible';
                                        currentButton.disabled = false;
                                    }
                                });
                            } else {
                                spinner.style.visibility = 'hidden'; // Hide spinner
                                buttonText.style.visibility = 'visible'; // Show text again
                                currentButton.disabled = false; // Re-enable the button
                            }
                        })
                }
            }
        );
    } else {
        // Browser doesn't support Geolocation
        console.log('error')
    }
}

async function saveCustomLocationHandle() {
    const elements = getZipPopupElements();
    if (!elements || !elements.input) {
        return;
    }

    const { input, zipMessage, spinner, textBtn, saveBtn } = elements;

    if (input.value.length === 5 && !isNaN(parseInt(input.value, 10))) {
        textBtn.style.visibility = 'hidden';
        spinner.style.visibility = 'visible';
        zipMessage.textContent = '';
        if (saveBtn) {
            saveBtn.disabled = true;
        }

        const result = await findZipcodeAndUpdateLocalStorage(input.value);

        if (!result.found) {
            zipMessage.textContent = 'Sorry, this zip code is not served in our delivery area.';
            zipMessage.style.color = 'red';
            resetSaveZipButton(elements);
        }
    } else {
        zipMessage.textContent = 'Invalid ZIP Code! Please enter a valid 5-digit ZIP code.';
        zipMessage.style.color = 'red';
    }
}

const LOCATION_URL_PARAM = 'location';

function getLocationAbrevFromUrl() {
    const locationAbrev = new URLSearchParams(window.location.search).get(LOCATION_URL_PARAM);
    return locationAbrev ? locationAbrev.toUpperCase() : null;
}

function removeLocationParamFromUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(LOCATION_URL_PARAM)) {
        return;
    }
    url.searchParams.delete(LOCATION_URL_PARAM);
    window.history.replaceState({}, '', url.toString());
}

function stateExistsInList(zipcodeList, stateAbrev) {
    return zipcodeList.some(item => item.location_abrev === stateAbrev);
}

function getPersistedLocationState() {
    const persisted = localStorage.getItem('user_location_state');
    return persisted ? persisted.toUpperCase() : null;
}

function setPersistedLocationState(stateAbrev) {
    if (stateAbrev) {
        localStorage.setItem('user_location_state', stateAbrev);
    }
}

function getCurrentLocationState() {
    return getPersistedLocationState();
}

/**
 * One-time ?location= handler: valid → that location; invalid → ATL. Always strips param from URL.
 */
function consumeLocationFromUrl(zipcodeList) {
    const urlLocation = getLocationAbrevFromUrl();
    if (!urlLocation) {
        return null;
    }

    removeLocationParamFromUrl();

    if (stateExistsInList(zipcodeList, urlLocation)) {
        return urlLocation;
    }
    return DEFAULT_LOCATION_STATE;
}

/** Persisted state → zip-derived state → ATL (first visit). */
function resolveStateAbrevFromStorage(zipcodeList) {
    const persistedState = getPersistedLocationState();
    if (persistedState && persistedState !== 'NOT FOUND') {
        return persistedState;
    }

    const savedZip = localStorage.getItem('user_zipcode');
    if (savedZip && savedZip !== 'not found') {
        const savedRow = zipcodeList.find(item => item.zipcode === savedZip);
        if (savedRow && savedRow.location_abrev) {
            return savedRow.location_abrev;
        }
    }

    return DEFAULT_LOCATION_STATE;
}

function applyLocationForState(zipcodeList, stateAbrev, options) {
    const forceFirstZip = options && options.forceFirstZip;
    const firstForState = findFirstLocationByState(zipcodeList, stateAbrev);
    const savedZip = localStorage.getItem('user_zipcode');
    const savedRow = savedZip ? zipcodeList.find(item => item.zipcode === savedZip) : null;
    const zipBelongsToState = savedRow && savedRow.location_abrev === stateAbrev;

    if (firstForState) {
        localStorage.setItem('current_location_id', firstForState.location_id);
        if (forceFirstZip || !savedZip || savedZip === 'not found' || !zipBelongsToState) {
            localStorage.setItem('user_zipcode', firstForState.zipcode);
        }
    } else {
        localStorage.setItem('current_location_id', 'not found');
        if (forceFirstZip || !savedZip || savedZip === 'not found') {
            localStorage.setItem('user_zipcode', 'not found');
        }
    }

    localStorage.removeItem('current_location_abrev');

    const resolvedState = firstForState ? firstForState.location_abrev : 'not found';
    setPersistedLocationState(resolvedState);
    updateZipcodeOutputs(localStorage.getItem('user_zipcode'));

    return {
        stateAbrev: resolvedState,
        locationId: localStorage.getItem('current_location_id'),
        zipcode: localStorage.getItem('user_zipcode'),
    };
}

/**
 * Resolve location from localStorage. Optional ?location= is consumed once then removed from URL.
 */
async function initLocationFromUrlOrDefault() {
    const zipcodeList = await getZipcodeList();
    const locationFromUrl = consumeLocationFromUrl(zipcodeList);

    if (locationFromUrl !== null) {
        return applyLocationForState(zipcodeList, locationFromUrl, { forceFirstZip: true });
    }

    const stateAbrev = resolveStateAbrevFromStorage(zipcodeList);
    return applyLocationForState(zipcodeList, stateAbrev, { forceFirstZip: false });
}

function reloadPagePreservingParams() {
    const url = new URL(window.location.href);
    url.searchParams.delete(LOCATION_URL_PARAM);
    localStorage.setItem('selected_variant_id', 'none');
    window.location.href = url.toString();
}

async function findZipcodeAndUpdateLocalStorage(zipcode) {
    const zipcodeList = await getZipcodeList();
    const currentLocation = zipcodeList.find(item => item.zipcode === zipcode);

    if (!currentLocation) {
        return { found: false };
    }

    localStorage.setItem('user_zipcode', zipcode);
    localStorage.setItem('current_location_id', currentLocation.location_id);
    setPersistedLocationState(currentLocation.location_abrev);
    localStorage.removeItem('current_location_abrev');
    reloadPagePreservingParams();
    return { found: true };
}

window.initLocationFromUrlOrDefault = initLocationFromUrlOrDefault;
window.getCurrentLocationState = getCurrentLocationState;
window.syncStateUrlFromZipcode = initLocationFromUrlOrDefault;

// Function to get the current search parameters as an object with numeric conversion
function getCurrentSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    searchParams.forEach((value, key) => {
        const numericValue = Number(value);
        params[key] = isNaN(numericValue) ? value : numericValue;  // Convert to number if applicable, otherwise keep as string
    });
    return params;
}

function noLocationHandle() {
    const variantsWrapper = document.querySelector('.ss--variant-wrapper')
    const quantityWrapper = document.querySelector('.ss--quantity-input__wrapper')
    const addToCartButton = document.querySelector('.ss--cta-button.add-to-cart')


    if (!window.inventories) {
        variantsWrapper.style.display = 'none';
        quantityWrapper.style.display = 'none';
        addToCartButton.style.display = 'none';
    }
}

// Setup to capture URL changes via history API
history.pushState = (f => function pushState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
})(history.pushState);

history.replaceState = (f => function replaceState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
})(history.replaceState);

window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
});

window.addEventListener('locationchange', function () {
    const params = getCurrentSearchParams();
    localStorage.setItem('selected_variant_id', `${params.variant}`)
});

// Log and return the search parameters immediately on page load
document.addEventListener('DOMContentLoaded', async (event) => {
    const isProductPage = document.querySelector('.ss--product-template__container')

    await initLocationFromUrlOrDefault();

    if (window.location.pathname.includes('products') == false) {
        localStorage.setItem('selected_variant_id', 'none')
    } else {
        const params = getCurrentSearchParams();
        localStorage.setItem('selected_variant_id', `${params.variant}`)
    }

    if (isProductPage && document.querySelector('.product-block--price') && !document.querySelector('.ss--inventory-control-message')) {
        await productDisplayPriceHandle();
    }
});

